// EXPERIMENT: sign_form_signer_carousel_colors_experiment — remove with experiment cleanup
import type React from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { ColoredSignerCarouselScheme } from '../../shared/carouselColorSchemes';
import { pickSignerPillColors } from '../../shared/carouselColorSchemes';
import type { RecentSigner } from '../../types';
import { ColoredSignerPill } from '../ColoredSignerPill';

/** `RecentSignersFeedItem`'s name, alt and metatext, rendered as a pill in the arm's colors. */
export const ColoredRecentSignersFeedItem: React.FC<Props> = ({ item, colorScheme, baseIndex }) => {
	const { translate } = useI18n();

	return (
		<ColoredSignerPill
			name={item.displayNameAbbreviated}
			metatext={translate('corgi.petition_gamma.petition_sign.recent_signers.signed', {
				createdAtRelativeLocalized: item.createdAtRelativeLocalized,
			})}
			photoUrl={item.photoUrl ?? undefined}
			colors={pickSignerPillColors(colorScheme, baseIndex)}
		/>
	);
};

type Props = Readonly<{
	item: RecentSigner;
	colorScheme: ColoredSignerCarouselScheme;
	/** The signer's index in the base list, before the feed doubles it. Picks the color in multi-color schemes. */
	baseIndex: number;
}>;
